// extracted by mini-css-extract-plugin
export var menuIcon = "_np-0";
export var menuIconInline = "_np-1";